export function generateReportName(reportName,app) {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = today.toLocaleString("en-US", { month: "short" });
  const year = today.getFullYear();
  const formattedDate = `${day}${month}${year}`;

  return (
    reportName + "_" +
    app.aplReferenceId + "_" +
    app.locClinicNumber + "_" +
    formattedDate
  );
}
